"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeismicCommon = void 0;
require("reflect-metadata");
var rxjs_1 = require("rxjs");
var typedi_1 = require("typedi");
var CommonService_decorator_1 = require("./decorators/CommonService.decorator");
var DecoratorMetadataStorage_1 = require("./decorators/DecoratorMetadataStorage");
var helper_1 = require("./helper");
var navigator_1 = require("./navigator");
var DateService_1 = require("./services/DateService");
var Deprecation_service_1 = require("./services/Deprecation.service");
var UserBehaviorTrack_service_1 = require("./services/UserBehaviorTrack.service");
var APISDK_factory_1 = require("./services/apiSDK/APISDK.factory");
var Authentication_service_1 = require("./services/authentication/Authentication.service");
var CentralEvents_service_1 = require("./services/centralEvents/CentralEvents.service");
var EventCollector_service_1 = require("./services/eventCollector/EventCollector.service");
var LegacyI18n_factory_1 = require("./services/legacyI18n/LegacyI18n.factory");
var angular_utils_1 = require("./util/angular/angular-utils");
var SeismicCommon = /** @class */ (function () {
    function SeismicCommon() {
        /**
         * __legacyCoreService is only a temporary solution for migrating seismic-core-service
         * into seismic-common. __legacyCoreService is going to be removed or modified soon.
         * You are NOT supposed to use __legacyCoreService for any other purpose.
         * Please try to reach Stone Sun if you have any question about this.
         */
        // tslint:disable-next-line variable-name
        this.__legacyCoreService = {};
        this.serviceAdded = new rxjs_1.ReplaySubject();
        this.helper = typedi_1.Container.get(helper_1.SeismicHelper);
        this.navigator = typedi_1.Container.get(navigator_1.SeismicNavigator);
        this.initLegacyCoreService();
    }
    SeismicCommon.prototype.initLegacyCoreService = function () {
        this.__legacyCoreService.dateHandler = typedi_1.Container.get(DateService_1.DateService);
        this.__legacyCoreService.userBehaviourTrack = typedi_1.Container.get(UserBehaviorTrack_service_1.UserBehaviorTrackService);
        this.__legacyCoreService.i18n = typedi_1.Container.get(LegacyI18n_factory_1.LegacyI18nFactory).create();
        this.__legacyCoreService.translator = this.__legacyCoreService.i18n;
        this.__legacyCoreService.Translate = typedi_1.Container.get(LegacyI18n_factory_1.LegacyI18nFactory).LegacyTranslate;
        this.__legacyCoreService.centralEvents = typedi_1.Container.get(CentralEvents_service_1.CentralEventsService);
        this.__legacyCoreService.eventCollector = typedi_1.Container.get(EventCollector_service_1.EventCollectorService);
        this.__legacyCoreService.authentication = typedi_1.Container.get(Authentication_service_1.AuthenticationService);
        this.__legacyCoreService.createAPISDK = typedi_1.Container.get(APISDK_factory_1.APISDKFactory).create;
        this.__legacyCoreService.fakeApiServiceFactory = typedi_1.Container.get(APISDK_factory_1.APISDKFactory).fakeApiServiceFactory;
        // When running in new cicd mode, you can also guarantee that external is available in webpack.
        window.SeismicCoreService = this.__legacyCoreService;
    };
    SeismicCommon.prototype.getService = function (type) {
        if (typeof (type) === 'string') {
            if (CommonService_decorator_1.commonServiceMap.has(type)) {
                return typedi_1.Container.get(CommonService_decorator_1.commonServiceMap.get(type));
            }
            else if (typedi_1.Container.has(type)) {
                return typedi_1.Container.get(type);
            }
            else {
                throw new Error('No service with name ' + type + ' was found. Please register your custom service or choose one from these: ' + __spreadArray([], __read(CommonService_decorator_1.commonServiceMap.keys())).join(',\n'));
            }
        }
        // // @ts-ignore
        // if (typeof (type) === 'function' && type[CommonServiceSymbol]) {
        // 	// @ts-ignore
        // 	type = type[CommonServiceSymbol] as any;
        // }
        return typedi_1.Container.get(type);
    };
    /**
     * Gets an angular service and will print out a warning if there is a seismic-common service that can replace it
     * If you're going to do something bad, you might as well do it in one place
     * @param serviceName
     */
    SeismicCommon.prototype.getAngularService = function (serviceName) {
        var _a;
        var commonServices = DecoratorMetadataStorage_1.getDecoratorMetadataStorage().findCommonServicesByAngularServiceName(serviceName);
        if (commonServices.length > 0) {
            console.warn("\nThe angular service " + serviceName + " can be replaced by seismic-common's service(s) " + commonServices.map(function (x) { return x.alias; }).join(', ') + ".\nimport {instance, " + commonServices.map(function (x) { return x.alias; }).join(', ') + " from 'seismic-common';\n" + commonServices.map(function (x) { return "const " + Deprecation_service_1.DeprecationService.toCamelCase(x.alias) + " = instance.getService(" + x.alias + ");"; }).join('\n') + "\n");
        }
        return (_a = angular_utils_1.getInjector()) === null || _a === void 0 ? void 0 : _a.get(serviceName);
    };
    SeismicCommon.prototype.setService = function (name, type) {
        typedi_1.Container.set(name, type);
    };
    return SeismicCommon;
}());
exports.SeismicCommon = SeismicCommon;
//# sourceMappingURL=SeismicCommon.js.map